import { useEffect } from 'react';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import SelectFundingMethod from '../../components/SelectFundingMethod/SelectFundingMethod';
import { ACCOUNT_TYPE_GTM } from '../../constants/sessionStorage';
import { useMenu } from '../../hooks/useMenu';
import { useMetalStreamData } from '../../hooks/useMetalStreamData';
import { metalStreamDataHelper } from '../../util/helpers/metalStreamDataHelper';
import { retrieveFromSessionStorage } from '../../util/helpers/sessionStorageHelper';
import useGtmStepHook from '../../util/hooks/useGtmStepHook';
import { gtmStepHelper } from '../../util/helpers/gtmHelper';
import { ACCOUNT_STEP_VIEW } from '../../util/gtmEvents';

const FundMetal = () => {
  const { activeMenu, activeItem } = useMenu();
  const { MetalStreamData } = useMetalStreamData();
  const silverPercentage = metalStreamDataHelper(
    MetalStreamData,
    'SilverPercentage',
  );

  const { gtmStepEvent } = useGtmStepHook();
  const accountGtmType = retrieveFromSessionStorage(ACCOUNT_TYPE_GTM);

  useEffect(() => {
    gtmStepHelper({
      gtmStepEvent,
      eventName: ACCOUNT_STEP_VIEW,
      stepLabel: 'Fund your account',
      accountType: accountGtmType,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={
        silverPercentage !== 0
          ? activeItem?.previousPath
          : activeItem?.preSkipPath
      }
    >
      <SelectFundingMethod nextPath={activeItem?.nextPath} />
    </OnBoardingContainer>
  );
};

export default FundMetal;
